import { addMonths } from "date-fns";

export const ACCESSIBLE_REFLOW_HEIGHT = `399px`;
export const EXTERNAL_ROLE = "EXTERNAL_COMMITTEE";
export const AWS_LAMBDA = "LAMBDA";
export const ACTION_STATUS = {
    ERROR: "error",
    FORBIDDEN: "forbidden",
    LOADING: "loading",
    NOT_FOUND: "notfound",
    SUCCESS: "success",
    UNAUTHORIZED: "unauthorized",
    GENERAL_ERROR: "General Error"
};
export const APPOINTMENT_STATUS = {
    Inactive: "N",
    Active: "Y"
}
export const ACTIVE = {
    NO: "N",
    YES: "Y"
};
export const AFFILIATION_TYPE = {
    DEPARTMENT_CHAIR: "DChair",
    GRADUATE_CHAIR: "GChair",
    GRADUATE_CONTACT: "GContact",
    GRADUATE_PROGRAM_INQUIRER: "GInquirer"
};
export const AFFILIATION = {
    [AFFILIATION_TYPE.DEPARTMENT_CHAIR]: "Department Chair",
    [AFFILIATION_TYPE.GRADUATE_CHAIR]: "Graduate Chair",
    [AFFILIATION_TYPE.GRADUATE_CONTACT]: "Graduate Contact",
    [AFFILIATION_TYPE.GRADUATE_PROGRAM_INQUIRER]: "Graduate Program Inquirer"
};
export const BOOL = {
    NO: "N",
    YES: "Y"
};

export const CACHE_KEYS = {
    darkMode: "darkMode",
    deviceSettings: "deviceSettings",
    on: "on",
    off: "off",
};
export const CACHE_OPTIONS = {
    [CACHE_KEYS.darkMode]: {
        [CACHE_KEYS.deviceSettings]: "device settings",
        [CACHE_KEYS.on]: "on",
        [CACHE_KEYS.off]: "off",
    }
};
let sixMonthsFromNow = new Date();
sixMonthsFromNow = addMonths(sixMonthsFromNow, 6);
sixMonthsFromNow = sixMonthsFromNow.getTime();
export const SIX_MONTHS_FROM_NOW = sixMonthsFromNow;

export const CATEGORY_M = "CM";
export const CATEGORY_P = "CP";
export const APPOINTMENT = {
    CATEGORY: {
        [CATEGORY_P]: "P",
        [CATEGORY_M]: "M",
    },
    FACULTY_TYPE: {
        AUTH: "Authorized",
        CONT: "Continuous",
        CTP: "CTP",
        CURR: "Current",
        EMER: "Emeritus"
    }
};
export const APPLICATION_ROLE = {
    CONTACT_APPROVER: "GRAD-SCHOOL-CONTACT-APPROVER",
    ENROLLMENT_ADMIN: "GRAD-SCHOOL-ENROLLMENT-ADMIN",
    FACULTY_APPROVER: "GRAD-SCHOOL-FACULTY-APPROVER",
    GRADUATE_APPROVER: "GRADUATE-APPROVER",
    GRADUATION_ADMIN: "GRAD-SCHOOL-GRADUATION-ADMIN",
    GRAD_STUDENT: "GRAD-SCHOOL-GRAD-STUDENT",
    INQUIRER: "GRAD-SCHOOL-INQUIRER",
    PROFESSIONAL_STUDENT: "GRAD-SCHOOL-PROFESSIONAL-STUDENT",
    UNDERGRAD_STUDENT: "GRAD-SCHOOL-UNDERGRAD_STUDENT"
};
export const APPLICATION_ROLE_GRAD_PLAN_ASSOCIATE_PREFIX = "GP#";
export const APPLICATION_ROLE_GRAD_PLAN_ADMIN_PREFIX = "GPADMIN#";
export const APPLICATION_ROLE_GRAD_FACULTY_PREFIX = "GF#";
export const APPLICATION_ROLE_GRADUATE_APPROVER_PREFIX = `${APPLICATION_ROLE.GRADUATE_APPROVER}#`;
export const APPLICATION_TIMEZONE = "America/New_York";
export const SYSTEM_ROLE = {
    [APPLICATION_ROLE.CONTACT_APPROVER]: "Graduate Contact Approver",
    [APPLICATION_ROLE.ENROLLMENT_ADMIN]: "Enrollment Admin",
    [APPLICATION_ROLE.FACULTY_APPROVER]: "Faculty Approver",
    [APPLICATION_ROLE.GRADUATION_ADMIN]: "Graduation Admin",
    [APPLICATION_ROLE.GRAD_STUDENT]: "Graduate Student",
    [APPLICATION_ROLE.INQUIRER]: "Inquirer",
    [APPLICATION_ROLE.UNDERGRAD_STUDENT]: "Undergraduate Student",
    [APPLICATION_ROLE_GRAD_PLAN_ASSOCIATE_PREFIX]: "Graduate Contact Inquirer",
    [APPLICATION_ROLE_GRAD_PLAN_ADMIN_PREFIX]: "Graduate Contact",
    [APPLICATION_ROLE_GRAD_FACULTY_PREFIX]: "Faculty",
    [APPLICATION_ROLE_GRADUATE_APPROVER_PREFIX]: "Graduate Approver"
};
export const CANDIDACY_TYPE = {
    FIRST_CANDIDACY: "FIRST_CANDIDACY",
    SECOND_CANDIDACY: "SECOND_CANDIDACY",
    SUPPLEMENTAL_CANDIDACY: "SUPPLEMENTAL_CANDIDACY"
};
export const CAREER = {
    GRAD: "GRAD",
    PROFESSIONAL: {
        DENT: "DENT",
        LAW: "LAW",
        MED: "MED",
        OPT: "OPT",
        PHP: "PHP",
        VMED: "VMED"
    }
};
export const CREDIT_TYPE = {
    GRADNONDEGREE: "GRADNONDEGREE",
    OUTSIDE_TRANSFER_COURSES: "OUTSIDE_TRANSFER_COURSES",
    OUTSIDE_TRANSFER_MASTERS_DEGREE: "OUTSIDE_TRANSFER_MASTERS_DEGREE",
    PREVIOUS_OSU_MASTERS_DEGREE: "PREVIOUS_OSU_MASTERS_DEGREE",
    SENIORPETITION: "SENIORPETITION"
};
export const CURRENT_CAREER = {
    GRAD: "GRAD",
    PROF: "PROF",
    UNDERGRAD: "UNDERGRAD"
};
export const DASHBOARD_OVERVIEW = {
    approvalTasks: {
        label: "Approval Tasks",
        path: "/tasks"
    },
    completionTasks: {
        label: "Completion Tasks",
        path: "/tasks"
    },
    pendingContacts: {
        label: "Pending Contacts",
        path: "/admin/pending-maintenance"
    },
    pendingFaculty: {
        label: "Pending Faculty",
        path: "/admin/pending-maintenance"
    }
};
export const DEGREE = {
    AUD: "AUD",
    CERTIFICATE: "CRT",
    DMA: "DMA",
    DNE: "DNE",
    DNP: "DNP",
    DPT: "DPT",
    EDD: "EDD",
    INTERDISCIPLINARY_SPECIALIZATION: "ISP",
    MINOR: "MIN",
    OTD: "OTD",
    PHD: "PHD",
    SPECIALIZATION: "SPC"
};
export const DELIMITER = {
    ACADEMIC_PLAN: "-"
};
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const ERROR_MESSAGE = {
    REQUIRED: "This field is required."
};
export const ERROR_TYPE = {
    NOT_FOUND: "Not Found",
    UNAUTHORIZED: "Unauthorized",
    VALIDATION: "ValidationError"
};
export const EXAM_EVAL_COMMENTS_MAX_LENGTH = 1500;
export const EXTERNAL_LINK_DESCRIPTOR = "external-link-helper";
export const EVENT_APPROVE_APPROVAL_FORM = "approveApprovalForm";
export const EVENT_SAVE_APPROVAL_FORM = "saveApprovalForm";
export const FINAL_EXAM_TYPE = {
    FIRST_FINAL_EXAM: "FIRST_FINAL_EXAM",
    SECOND_FINAL_EXAM: "SECOND_FINAL_EXAM"
};
export const FORCED_AUTHENTICATION = process.env.REACT_APP_FORCED_AUTHENTICATION === "true";
export const GPA_MAX_LENGTH = "4";
export const GRAD_LEVEL = {
    CERTIFICATE: "Certificate",
    DMA: "DMA",
    DOCTORAL: "Doctoral",
    EDUCATIONAL_SPECIALIST: "Educational Specialist",
    INTERDISC_SPEC: "Interdisc Spec",
    MASTER: "Master",
    MASTERCB: "MasterCB",
    MINOR: "Minor",
    PROFESSIONAL: "Professional",
    SPECIALIZATION: "Specialization"
};
export const GRAD_SCHOOL_FAX_NUMBER = "614-292-3656";
export const GRAD_SCHOOL_GRADUATION_DEADLINES_URL = "https://gradsch.osu.edu/graduation-calendar-0";
export const GRAD_SCHOOL_HANDBOOK_URL = "https://gradsch.osu.edu/graduate-school-handbook-gsh";
export const GRAD_SCHOOL_PETITIONS_EMAIL = "grad-schoolpetitions@osu.edu";
export const GRAD_SCHOOL_PHONE_NUMBER = "614-292-6031";
export const GRAD_SCHOOL_REGISTRATION_SERVICES_EMAIL = "grad-schoolregistrationservices@osu.edu";
export const OPENS_NEW_WINDOW_DESCRIPTOR = "opens-new-window-helper";
export const OSU_NAV_ID = 'osu-navbar';
export const PROFESSIONAL_DEGREES = [DEGREE.AUD, DEGREE.DNE, DEGREE.DNP, DEGREE.DPT, DEGREE.EDD, DEGREE.OTD];
export const PROFESSIONAL_EXAM_TYPE = {
    FIRST_PROFESSIONAL_EXAM: "FIRST_PROFESSIONAL_EXAM",
    SECOND_PROFESSIONAL_EXAM: "SECOND_PROFESSIONAL_EXAM"
};
export const NAVBAR_WRAPPER_ID = "app-header";
export const MAIN_ID = 'page-content';
export const SORT_DIRECTION = {
    ASCENDING: "asc",
    DESCENDING: "desc"
};
export const STATUS = {
    ACTIVE: "Active",
    INACTIVE: "Inactive"
};
export const TOC_WIDTH = `15rem`;
export const MAX_LENGTH_EMPLID = '9'

export const formCategoryIdentifiers = {
    FORM_CATEGORY: "FORM_CATEGORY",
    GRADUATION_AND_EXAMINATION: "GRADUATION_AND_EXAMINATION",
    ENROLLMENT: "ENROLLMENT",
    REPORTS: "REPORTS"
}

export const FORM_CATEGORY = {
    [formCategoryIdentifiers.GRADUATION_AND_EXAMINATION]: "Graduation and Examination",
    [formCategoryIdentifiers.ENROLLMENT]: "Enrollment",
    [formCategoryIdentifiers.REPORTS]: "Reports",
}

export const FORM_HISTORY_STEP = {
    COMPLETION: "COMPLETION",
    GRAD_SCHOOL_REVIEW: "GRAD_SCHOOL_REVIEW",
    PROGRAM_REVIEW: "PROGRAM_REVIEW",
    SUBMITTED: "SUBMITTED"
};

export const FORM_HISTORY_LABEL = {
    [FORM_HISTORY_STEP.COMPLETION]: "Completion",
    [FORM_HISTORY_STEP.GRAD_SCHOOL_REVIEW]: "Graduate School Review",
    [FORM_HISTORY_STEP.PROGRAM_REVIEW]: "Program Review",
    [FORM_HISTORY_STEP.SUBMITTED]: "Submitted"
};

export const reportTypeIdentifiers = {
    REPORT_ON_CANDIDACY: "REPORT_ON_CANDIDACY",
    REPORT_ON_FINAL_DOCUMENT: "REPORT_ON_FINAL_DOCUMENT",
    REPORT_ON_FINAL_EXAM: "REPORT_ON_FINAL_EXAM",
    REPORT_ON_PROF_EXAM: "REPORT_ON_PROF_EXAM"
};

export const formTypeIdentifiers = {
    FORM_TYPE: "FORM_TYPE",
    MINORS_AND_SPECIALIZATIONS: "MINORS_AND_SPECIALIZATIONS",
    REPORT_ON_FINAL_DOCUMENT: reportTypeIdentifiers.REPORT_ON_FINAL_DOCUMENT,
    APPLICATION_FOR_CANDIDACY_EXAM: "APPLICATION_FOR_CANDIDACY_EXAM",
    APPLICATION_TO_GRADUATE: "APPLICATION_TO_GRADUATE",
    COMBINED_DEGREE_PROGRAM: "COMBINED_DEGREE_PROGRAM",
    GRAD_FACULTY_NOMINATION: "GRAD_FACULTY_NOMINATION",
    LATE_COURSE_PETITION: "LATE_COURSE_PETITION",
    APPLICATION_FOR_CERTIFICATE_COMPLETION: "APPLICATION_FOR_CERTIFICATE_COMPLETION",
    APPLICATION_FOR_FINAL_EXAM: "APPLICATION_FOR_FINAL_EXAM",
    LEAVE_OF_ABSENCE_FROM_PROGRAM: "LEAVE_OF_ABSENCE_FROM_PROGRAM",
    DUAL_DEGREE_PROGRAM: "DUAL_DEGREE_PROGRAM",
    SPECIALIZATION: "SPECIALIZATION",
    TRANSFER_GRADUATE_CREDIT: "TRANSFER_GRADUATE_CREDIT",
    WITHDRAWAL_FROM_PROGRAM: "WITHDRAWAL_FROM_PROGRAM",
    APPLICATION_FOR_PROFESSIONAL_EXAM: "APPLICATION_FOR_PROFESSIONAL_EXAM",
    DELAY_OF_FINAL_DOCUMENT: "DELAY_OF_FINAL_DOCUMENT",
    REPORT_ON_CANDIDACY: reportTypeIdentifiers.REPORT_ON_CANDIDACY,
    REPORT_ON_FINAL_EXAM: reportTypeIdentifiers.REPORT_ON_FINAL_EXAM,
    COMMITTEE_AND_EXAM_PETITION: "COMMITTEE_AND_EXAM_PETITION",
    REPORT_ON_PROF_EXAM: reportTypeIdentifiers.REPORT_ON_PROF_EXAM,
    TRANSFER_GRAD_PROGRAM: "TRANSFER_GRAD_PROGRAM"
}

export const formTypeIdentifiersProfessional = [
    formTypeIdentifiers.COMBINED_DEGREE_PROGRAM,
    formTypeIdentifiers.MINORS_AND_SPECIALIZATIONS
];
export const formTypeIdentifiersUnderGrad = [formTypeIdentifiers.COMBINED_DEGREE_PROGRAM];

export const FORM_TYPE = {
    [formTypeIdentifiers.APPLICATION_FOR_CANDIDACY_EXAM]: "Application For Candidacy Exam",
    [formTypeIdentifiers.APPLICATION_FOR_CERTIFICATE_COMPLETION]: "Application For Certificate Completion",
    [formTypeIdentifiers.APPLICATION_FOR_FINAL_EXAM]: "Application For Final Examination",
    [formTypeIdentifiers.APPLICATION_FOR_PROFESSIONAL_EXAM]: "Application For Professional Examination",
    [formTypeIdentifiers.APPLICATION_TO_GRADUATE]: "Application To Graduate",
    [formTypeIdentifiers.COMBINED_DEGREE_PROGRAM]: "Combined Degree Program Plan",
    [formTypeIdentifiers.COMMITTEE_AND_EXAM_PETITION]: "Committee And Examination Petition",
    [formTypeIdentifiers.DELAY_OF_FINAL_DOCUMENT]: "Delay Of Final Document",
    [formTypeIdentifiers.DUAL_DEGREE_PROGRAM]: "Dual Degree Program",
    [formTypeIdentifiers.GRAD_FACULTY_NOMINATION]: "Grad Faculty Nomination",
    [formTypeIdentifiers.LATE_COURSE_PETITION]: "Late Course Petition",
    [formTypeIdentifiers.LEAVE_OF_ABSENCE_FROM_PROGRAM]: "Leave Of Absence From Program",
    [formTypeIdentifiers.MINORS_AND_SPECIALIZATIONS]: "Minors & Interdisciplinary Specializations",
    [formTypeIdentifiers.REPORT_ON_CANDIDACY]: "Report On Candidacy",
    [formTypeIdentifiers.REPORT_ON_FINAL_DOCUMENT]: "Report On Final Document",
    [formTypeIdentifiers.REPORT_ON_FINAL_EXAM]: "Report On Final Examination",
    [formTypeIdentifiers.REPORT_ON_PROF_EXAM]: "Report on Professional Examination",
    [formTypeIdentifiers.SPECIALIZATION]: "Specialization",
    [formTypeIdentifiers.TRANSFER_GRADUATE_CREDIT]: "Transfer of Graduate Credit",
    [formTypeIdentifiers.WITHDRAWAL_FROM_PROGRAM]: "Withdrawal From Program"
};

export const FORM_TYPE_HTML_FRIENDLY = {
    [formTypeIdentifiers.APPLICATION_TO_GRADUATE]: "application-to-graduate",
    [formTypeIdentifiers.APPLICATION_FOR_CANDIDACY_EXAM]: "application-for-candidacy-exam",
    [formTypeIdentifiers.APPLICATION_FOR_CERTIFICATE_COMPLETION]: "application-for-certificate-completion",
    [formTypeIdentifiers.APPLICATION_FOR_FINAL_EXAM]: "application-for-final-examination",
    [formTypeIdentifiers.APPLICATION_FOR_PROFESSIONAL_EXAM]: "application-for-professional-examination",
    [formTypeIdentifiers.MINORS_AND_SPECIALIZATIONS]: "minors-and-interdisciplinary-specializations",
    [formTypeIdentifiers.REPORT_ON_FINAL_DOCUMENT]: "report-on-final-document",
    [formTypeIdentifiers.COMBINED_DEGREE_PROGRAM]: "combined-degree-program",
    [formTypeIdentifiers.GRAD_FACULTY_NOMINATION]: "graduate-faculty-nomination",
    [formTypeIdentifiers.LATE_COURSE_PETITION]: "late-course-petition",
    [formTypeIdentifiers.LEAVE_OF_ABSENCE_FROM_PROGRAM]: "leave-of-absence-from-program",
    [formTypeIdentifiers.DUAL_DEGREE_PROGRAM]: "dual-degree-program-plan",
    [formTypeIdentifiers.SPECIALIZATION]: "specialization",
    [formTypeIdentifiers.TRANSFER_GRADUATE_CREDIT]: "transfer-of-graduate-credit",
    [formTypeIdentifiers.WITHDRAWAL_FROM_PROGRAM]: "withdrawal-from-program",
    [formTypeIdentifiers.DELAY_OF_FINAL_DOCUMENT]: "delay-of-final-document",
    [formTypeIdentifiers.REPORT_ON_CANDIDACY]: "report-on-candidacy",
    [formTypeIdentifiers.REPORT_ON_FINAL_EXAM]: "report-on-final-examination",
    [formTypeIdentifiers.COMMITTEE_AND_EXAM_PETITION]: "committee-and-examination-petition",
    [formTypeIdentifiers.REPORT_ON_PROF_EXAM]: "report-on-professional-examination",
    [formTypeIdentifiers.TRANSFER_GRAD_PROGRAM]: "transfer-graduate-program"
};

export const FORMS_WITH_COMMITTEE = [formTypeIdentifiers.APPLICATION_FOR_FINAL_EXAM];

export const APPROVAL_STATUS = {
    APPROVED: "APPROVED",
    CANCELLED: "CANCELLED",
    COMPLETED: "COMPLETED",
    DENIED: "DENIED",
    DRAFT: "DRAFT",
    FINAL_REVIEW: "GRAD_SCHOOL_REVIEW",
    INITIAL_REVIEW: "INITIAL_REVIEW",
    PENDING: "PENDING",
    SATISFACTORY: "SATISFACTORY",
    UNSATISFACTORY: "UNSATISFACTORY"
};

export const APPROVAL_SUBSTATUS = {
    GS_PENDING: "GS_PENDING",
    DEPT_PENDING: "DEPT_PENDING"
};

export const DAYS_OVERDUE = 5
export const SUPPORT_EMAIL = {
    GRAD_FORMS: "GRAD-osi@osu.edu",
    GRADUATION_SERVICES: "Grad-SchoolGraduationServices@osu.edu",
    REGISTRATION_SERVICES: "Grad-SchoolRegistrationServices@osu.edu"
};

export const personInfo = {
    read:  {
        emplid: "OSUID",
        nameN: "Name .#",
        firstName: "First Name",
        lastName: "Last Name",
        middleName: "Middle Name",
        facultyEmail: "Faculty Email",
        facultyType: "Faculty Type",
        phone: "Phone",
        program: "Program",
        category: "Category"
    },
    write:  {
        emplid: "OSUID",
        nameN: "Name .#",
        firstName: "First Name",
        lastName: "Last Name",
        middleName: "Middle Name",
        facultyEmail: "Faculty Email",
        facultyType: "Faculty Type",
        facultyNomination: "Faculty Nomination",
        phone: "Phone",
        program: "Program",
        category: "Category"
    },
    transform: {
        category: (category) => (APPOINTMENT.CATEGORY[category]),
        facultyType: (facultyType) => (APPOINTMENT.FACULTY_TYPE[facultyType])
    }
}

export const WorkflowApprovalTask = {
    ADVISOR_APPROVAL: 'ADVISOR_APPROVAL',
    GRAD_CHAIR_COORDINATOR_APPROVAL: 'GRAD_CHAIR_COORDINATOR_APPROVAL',
    GRAD_FACULTY_REP_APPROVAL: 'GRAD_FACULTY_REP_APPROVAL',
    GRADSCHOOL_APPROVAL: 'GRADSCHOOL_APPROVAL',
    GRADSCHOOL_PRE_APPROVAL: 'GRADSCHOOL_PRE_APPROVAL',
    FINAL_APPROVAL: 'FINAL_APPROVAL'
}

export const TIME_FORMAT = 'hh:mm aa'
export const DATE_FORMAT = "MM/dd/yyyy"

export const TASK_ACTION_TRANSFER = "TRANSFER";
export const TASK_ACTION = {
    COMPLETE: "Complete",
    RESEND_EMAIL: "Resend Email",
    [TASK_ACTION_TRANSFER]: "Transfer"
}

export const LEAVE_REASON = {
    FAMILY: "FAMILY",
	FINANCIAL: "FINANCIAL",
	MEDICAL: "MEDICAL",
	MILITARY: "MILITARY",
	OTHER: "OTHER",
	PROFESSIONAL_OPPORTUNITY: "PROFESSIONAL_OPPORTUNITY"
};

export const WITHDRAWAL_REASON = {
    FAMILY: "FAMILY",
	FINANCIAL: "FINANCIAL",
	MEDICAL: "MEDICAL",
	MILITARY: "MILITARY",
	OTHER: "OTHER",
	PROFESSIONAL_OPPORTUNITY: "PROFESSIONAL_OPPORTUNITY"
};

export const STORAGE_KEY_STUDENT_PROXY = "studentProxy";
export const STORAGE_KEY_EXTERNAL_USER_KEYS = "externalUserKeys";
